export default __webpack_public_path__ + "static/DesktopMediaMainBanner-d363d7918f6a1164dc4daaf70bcc4396.png";